var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarseat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(-313.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(27 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(-108.483 1474.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436-2",
    "data-name": "Group 436",
    transform: "translate(469 1215.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M70.314,518.029a3.872,3.872,0,0,1-.97-5.606c2.264-3.557,7.33-12.289,7.33-12.289s.97-1.94,5.174-3.773,5.174-2.7,7.223-6.145c.108,0,1.617-4.312,4.743-2.587s7.654,2.8,5.821,6.468-3.45,4.851-2.911,7.869,2.587,7.223,0,11.319-7.654,12.5-7.654,12.5-1.94,2.372-5.713,0S70.314,518.029,70.314,518.029Z",
    transform: "translate(-68.539 -477.113)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M137,618s.323,2.372,9.81,5.821,10.457,6.9,10.457,6.9",
    transform: "translate(-128.326 -595.409)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M279.342,409.925s2.156-1.725,0-3.018-3.342-1.94-3.342-1.94l1.294-2.048,7.869-2.264s1.186-1.186,5.39,1.294,7.115,4.42,7.115,4.42l-3.234,5.39-5.282-3.018-3.989,4.743Z",
    transform: "translate(-254.716 -400.371)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M397,481s.431,7.115,4.528,11.1",
    transform: "translate(-362.288 -471.453)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M0,0,3.881,1.294",
    transform: "translate(47.447 9.215) rotate(-9)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M0,0,3.482,1.232",
    transform: "translate(46.288 11.7) rotate(3)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M0,0,3.482,1.232",
    transform: "translate(45.442 13.843) rotate(29)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M0,0,3.881,1.294",
    transform: "translate(54.755 11.303) rotate(-2)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M0,0,3.955,1.333",
    transform: "matrix(0.993, 0.122, -0.122, 0.993, 52.782, 14.952)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M0,0,3.955,1.333",
    transform: "matrix(0.946, 0.326, -0.326, 0.946, 50.417, 18.389)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(472.412 1215.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M73.8,981.626l-1.96-14.373s-1.814-14.047,9.473-11.76c-.327.327,42.14,9.147,42.14,9.147l7.84-6.207s7.84-3.92,11.107,1.307c.653.98,0,21.887,0,21.887Z",
    transform: "translate(-71.732 -893.426)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M460.6,1059.411s-.327-7.84,10.453-16.987",
    transform: "translate(-419.638 -971.211)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M547.83,605.614s-8.125-6.223,1.446-21.116c.327.327,6.6-11.2,6.6-11.2a30.66,30.66,0,0,0,3.234-9.385c.084-.3,1.109-5.944,8.134-6.86,5.665-.141,9.114,0,9.114,0s4.933,0,3.3,6.86c-.327.653-14.942,46.468-14.942,46.468",
    transform: "translate(-493.744 -537.114)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M710.5,359.644s-6.131-5.871,0-12.454c0-.178,17.25,0,17.25,0s6.443,6.227,0,12.454A71.888,71.888,0,0,1,710.5,359.644Z",
    transform: "translate(-639.222 -347.111)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarseat);
export default __webpack_public_path__ + "static/media/carseat.eb91daa7c7618514e3b18de028405c27.svg";
export { ForwardRef as ReactComponent };